'use strict';

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cookie = require('./cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_CONTENT_TYPE = 'application/x-www-form-urlencoded; charset=UTF-8';

var Request = function () {
    function Request(url) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var _ref$headers = _ref.headers,
            headers = _ref$headers === undefined ? {} : _ref$headers,
            _ref$method = _ref.method,
            method = _ref$method === undefined ? 'GET' : _ref$method,
            _ref$data = _ref.data,
            data = _ref$data === undefined ? null : _ref$data,
            _ref$dataType = _ref.dataType,
            dataType = _ref$dataType === undefined ? 'json' : _ref$dataType,
            _ref$type = _ref.type,
            type = _ref$type === undefined ? 'normal' : _ref$type,
            _ref$timeout = _ref.timeout,
            timeout = _ref$timeout === undefined ? 5000 : _ref$timeout,
            _ref$credentials = _ref.credentials,
            credentials = _ref$credentials === undefined ? 'include' : _ref$credentials,
            _ref$cors = _ref.cors,
            cors = _ref$cors === undefined ? true : _ref$cors,
            _ref$jsonp = _ref.jsonp,
            jsonp = _ref$jsonp === undefined ? 'callback' : _ref$jsonp,
            jsonpCallback = _ref.jsonpCallback,
            _ref$cache = _ref.cache,
            cache = _ref$cache === undefined ? 'default' : _ref$cache,
            _ref$fetchInit = _ref.fetchInit,
            fetchInit = _ref$fetchInit === undefined ? {} : _ref$fetchInit,
            externals = _objectWithoutProperties(_ref, ['headers', 'method', 'data', 'dataType', 'type', 'timeout', 'credentials', 'cors', 'jsonp', 'jsonpCallback', 'cache', 'fetchInit']);

        _classCallCheck(this, Request);

        this.context = 'puck';
        this.originUrl = '';
        this.cookies = new _cookie2['default']();
        this.mode = 'same-origin';

        if (!url) {
            throw new TypeError('Url must define');
        }

        this.method = method.toUpperCase();
        this.dataType = dataType;
        this.type = type;
        this.timeout = timeout;
        this.credentials = credentials;
        this.mode = cors ? 'cors' : 'same-origin';
        this.jsonpCallback = jsonpCallback;
        this.jsonp = jsonp;
        this.cache = cache;
        this.url = this.originUrl = url;
        this.fetchInit = fetchInit;
        this.externals = externals;

        if (_utils.isWeb) {
            this._processData = window.FormData ? !(data instanceof FormData || data instanceof Blob || data instanceof ArrayBuffer) : true;
        } else {
            this._processData = true;
        }

        if (_utils.isWeb) {
            headers = new Headers(headers || {});
            if (this._processData && !headers.has('Content-Type')) {
                headers.set('Content-Type', DEFAULT_CONTENT_TYPE);
            }
        }
        this.headers = headers;

        // data的设置依赖headers(Content-Type)选项
        this.data = data;

        if (this.method === 'GET') {
            this.url = (0, _utils.addQueryString)(url, this.serializeData);
        }
    }

    // 原始数据


    // eslint-disable-next-line
    /**
     * 序列化逻辑
     * formData，Blob,ArrayBuffer不需要序列化
     * 序列化
     *    - application/x-www-form-urlencoded: serialize
     *    - application/json: JSON.stringify
     * @param data
     * @returns {*}
     * @private
     */
    Request.prototype._serialize = function _serialize(data) {
        switch (typeof data === 'undefined' ? 'undefined' : _typeof(data)) {
            case 'string':
                return data;
            case 'function':
                return this._serialize(data());
            case 'object':
                if (Array.isArray(data)) {
                    throw new TypeError('Not support type of data: Array');
                }
                return this._processData ? this.headers.get('Content-Type').toLowerCase() === 'application/json' ? JSON.stringify(data) : (0, _utils.serialize)(data) : data;
            default:
                throw new TypeError('Not support type of data: ' + (typeof data === 'undefined' ? 'undefined' : _typeof(data)));
        }
    };

    Request.prototype._patchUrl = function _patchUrl() {
        var method = this.method;

        if (method !== 'GET') {
            return;
        }
        var queryObj = this.query;
        var data = (0, _utils.parseQuery)(this._serializeData);
        for (var key in data) {
            queryObj[key] = data[key];
        }
        this.query = queryObj;
    };

    _createClass(Request, [{
        key: 'data',
        get: function get() {
            return this._data;
        },
        set: function set(val) {
            this._data = val;
            this._serializeData = this._serialize(val);
            this._patchUrl();
        }

        // 序列化数据

    }, {
        key: 'serializeData',
        get: function get() {
            return this._serializeData;
        }
    }, {
        key: 'query',
        get: function get() {
            var url = this.url;
            var queryStr = url.indexOf('?') !== -1 ? url.substr(url.indexOf('?') + 1) || '' : '';
            return (0, _utils.parseQuery)(queryStr);
        },
        set: function set(queryObj) {
            var queryStr = (0, _utils.serialize)(queryObj);
            this.url = this.url.split('?')[0] + '?' + queryStr;
        }
    }]);

    return Request;
}();

exports['default'] = Request;
module.exports = exports['default'];